import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative overflow-hidden pt-32 pb-24 px-6 md:px-12 text-center z-10">
      <div className="max-w-4xl mx-auto relative z-10">
        <span className="section-badge">Eco World Capital (EWC)</span>

        <h1 className="mt-8 text-4xl md:text-6xl lg:text-7xl gradient-heading leading-tight pb-2 drop-shadow-md">
          Your Trusted Partner for Financial Growth
        </h1>
        <p className="mt-2 text-2xl md:text-3xl font-bold text-brand-cream-muted">
          & Advanced Trading Technology
        </p>

        <p className="mt-8 text-lg md:text-xl text-brand-cream-muted max-w-2xl mx-auto font-medium leading-relaxed drop-shadow-sm">
          A diversified financial services and financial technology company dedicated to providing comprehensive investment, trading, and funding solutions.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row justify-center items-center gap-6">
          <Link to="/services" className="w-full sm:w-auto btn-primary text-lg px-10 py-4 shimmer-hover inline-flex justify-center">
            Explore Solutions
          </Link>

          <Link to="/contact" className="w-full sm:w-auto btn-secondary text-lg px-10 py-4 inline-flex justify-center">
            Request Demo
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
